import { memo } from "react";
import type { AffiliationActionResult, AffiliationOrganization } from "../types";
import { AddAffiliationDialog } from "./AddAffiliationDialog";

/** Nada bloqueado na busca (a própria organização a busca já remove). */
const NO_BLOCKED_TOKENS = new Set<string>();

/**
 * "Receber teleconsultoria": a afiliada escolhe a prestadora.
 * Mesma busca e mesmo diálogo de adicionar afiliada, com os textos do pedido.
 * As regras (ex.: a prestadora precisa ter a extensão) são validadas ao confirmar.
 */
export const SelectProviderDialog = memo(function SelectProviderDialog({
  isOpen,
  isSaving,
  onClose,
  onConfirm,
}: {
  isOpen: boolean;
  isSaving: boolean;
  onClose: () => void;
  onConfirm: (provider: AffiliationOrganization) => Promise<AffiliationActionResult>;
}) {
  return (
    <AddAffiliationDialog
      isOpen={isOpen}
      isSaving={isSaving}
      blockedTokens={NO_BLOCKED_TOKENS}
      onClose={onClose}
      onConfirm={onConfirm}
      title="Selecionar prestadora"
      description="Escolha a organização que vai prestar teleconsultoria para a sua clínica. O pedido fica aguardando a aprovação dela; depois disso, vocês poderão marcar com os teleconsultores dela."
      confirmLabel="Enviar pedido"
    />
  );
});
